<template>
  <div class="dashboard-container">
    <div class="back-workbench" @click="goToWorkbench">
      <span class="arrow">←</span>
      <span>返回工作台</span>
    </div>
    <!-- 顶部头部 -->
    <div class="page-header">
      <div class="header-left">经营驾驶舱 门店运营 / 培训学习 / 任务执行 ·一站式洞察</div>
    </div>


    <!-- 筛选栏 -->
    <div class="filter-wrap">
      <div class="time-tab-wrap">
        <span
          v-for="item in timeTabList"
          :key="item.type"
          class="time-tab"
          :class="{active: activeTime === item.type}"
          @click="switchTime(item.type)"
        >
          {{ item.label }}
        </span>
      </div>
<!--      <div class="select-group">-->
<!--        <el-select v-model="queryParams.country" placeholder="全国" size="mini">-->
<!--          <el-option label="全国" value=""></el-option>-->
<!--        </el-select>-->
<!--        <el-select v-model="queryParams.province" placeholder="全部省份" size="mini">-->
<!--          <el-option label="全部省份" value=""></el-option>-->
<!--        </el-select>-->
<!--        <el-select v-model="queryParams.city" placeholder="全部城市" size="mini">-->
<!--          <el-option label="全部城市" value=""></el-option>-->
<!--        </el-select>-->
<!--      </div>-->
    </div>

    <!-- 顶部指标卡片行 -->
    <div class="indicator-row">
      <div class="indicator-card" v-for="(item, idx) in indicatorData" :key="idx">
        <div class="num">{{ item.value }}</div>
        <div class="label">{{ item.label }}</div>
        <div :class="['compare-text', item.up ? 'text-green' : 'text-red']">
          {{ item.compareText }}
        </div>
      </div>
    </div>

    <!-- 第一行图表：雷达图 + 门店监控榜单 -->
    <div class="chart-row two-col">
      <div class="chart-card">
        <div class="card-title">{{ timeTextMap[activeTime].current }}·执行力对比 <span class="legend-desc"><span class="green-block"></span>{{ timeTextMap[activeTime].current }}完成 <span class="gray-block"></span>上月完成</span></div>
        <div class="bar-scroll-wrap">
          <div ref="radarRef" class="chart-dom"></div>
        </div>
      </div>
      <div class="chart-card">
        <div class="card-title">{{ timeTextMap[activeTime].current }}·门店执行力监控榜 <span class="sub-tip">按综合完成率排序</span></div>
        <div class="tab-wrap">
            <span
              class="tab-item"
              :class="{active: activeTab === 'attention'}"
              @click="activeTab = 'attention'"
            >
              待关注门店（{{ this.attentions.length }}家）
            </span>
            <span
              class="tab-item"
              :class="{active: activeTab === 'excellent'}"
              @click="activeTab = 'excellent'"
            >
              优秀门店 TOP 50
            </span>
        </div>
        <el-table
          :data="tableList"
          border
          size="mini"
          height="300"
        >
<!--          <el-table-column label="排名" width="60" align="center" />-->
          <el-table-column label="排名" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="门店名称">
            <template slot-scope="scope">
              <div>{{ scope.row.shopName }}</div>
              <div class="small-desc">{{ scope.row.region }} / 店长 {{ scope.row.manager }}</div>
            </template>
          </el-table-column>
          <el-table-column label="完成率" width="80" align="center">
            <template slot-scope="scope">{{ scope.row.rate }}%</template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 第二行图表：区域柱状图 + 区域排行 -->
    <div class="chart-row two-col">
      <div class="chart-card">
        <div class="card-title">{{ timeTextMap[activeTime].current }}·区域执行力对比</div>
        <div ref="barRef" class="chart-dom"></div>
      </div>
      <div class="chart-card">
        <div class="card-title">{{ timeTextMap[activeTime].current }}·区域综合排行</div>
        <el-table
          :data="regionRankList"
          border
          size="mini"
          height="300"
        >
          <!-- 名次（排名） -->
          <el-table-column label="名次" width="60" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>

          <!-- 区域名称 -->
          <el-table-column label="区域">
            <template slot-scope="scope">
              {{ scope.row.area }}
            </template>
          </el-table-column>

          <!-- 综合完成率进度条 -->
          <el-table-column label="综合完成率">
            <template slot-scope="scope">
              <div class="progress-box">
                <div class="progress-bar" :style="{width: scope.row.rate + '%'}"></div>
                <span class="progress-text">{{ scope.row.rate }}%</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 业务详情模块 -->
    <div class="full-card">
      <div class="card-title">{{ timeTextMap[activeTime].current }}·业务详情</div>
      <div class="business-grid">
        <div class="business-item" v-for="(biz, idx) in businessList" :key="idx">
          <div class="biz-title">{{ biz.title }}</div>
          <div class="biz-row" v-for="(row, ri) in biz.rows" :key="ri">
            <span v-for="cell in row" :key="cell.label">{{ cell.label }}：{{ cell.val }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 完成率趋势折线图 -->
    <div class="full-card">
      <div class="card-title">{{ timeTextMap[activeTime].current }}·完成率趋势</div>
      <div ref="lineRef" class="chart-dom"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import { map } from 'lodash'
import moment from 'moment'

export default {
  name: 'Dashboard',
  data() {
    return {
      // 时间tab
      currentTimeTab: 'month',
      activeTab: 'attention', // 默认展示待关注门店
      attentions: [], // 待关注门店数据源
      excellents: [], // 优秀门店数据源
      activeTime: '1',
      timeTabList: [//1:昨天 2:本周 3:本月 4:本季度 5:本年
        { label: '昨天', type: '1' },
        { label: '本周', type: '2' },
        { label: '本月', type: '3' },
        { label: '本季度', type: '4' },
        { label: '本年', type: '5' }
      ],
      timeTextMap: {
        '1': { current: '昨日', prev: '前日' },
        '2': { current: '本周', prev: '上周' },
        '3': { current: '本月', prev: '上月' },
        '4': { current: '本季度', prev: '上季度' },
        '5': { current: '本年', prev: '上年' }
      },
      // 筛选参数
      queryParams: {
        country: '',
        province: '',
        city: ''
      },
      // 顶部指标数据
      indicatorData: [
        { label: '门店数', value: '528', compareText: '本月新增12家', up: true },
        { label: '活跃门店率', value: '86.5', compareText: '较上月 ↑ 2.3%', up: true },
        { label: '任务总完成率', value: '78.4', compareText: '较上月 ↓ 1.6%', up: false },
        { label: '待关注门店', value: '32', compareText: '完成率 < 60%', up: false },
        { label: '超期任务', value: '147', compareText: '较上月 ↑ 18 项', up: false },
        { label: '课程平均完成率', value: '72.3', compareText: '较上月 ↑ 4.1%', up: true }
      ],
      // 门店排名
      shopRankList: [
        { shopName: '沈阳中街旗舰店', region: '华北区', manager: '张某', rate: 59 },
        { shopName: '兰州西关百盛店', region: '华西区', manager: '王某', rate: 58 },
      ],
      // 区域排行
      regionRankList: [
        { area: '华东区', rate: 92.3 },
      ],
      // 业务详情数据
      businessList: [
        {
          title: '巡店任务',
          rows: [
            [{ label: '本月巡店', val: 312 }, { label: '平均得分', val: 82.6 }],
            [{ label: '不合格项', val: 186 }, { label: '整改完成', val: 73 }]
          ]
        },
        {
          title: '活动陈列',
          rows: [
            [{ label: '本月活动', val: 24 }, { label: '提交单', val: 88 }],
            [{ label: '审核通过', val: 76 }, { label: '待审核', val: 42 }]
          ]
        },
        {
          title: '开放问卷',
          rows: [
            [{ label: '本月问卷', val: 8 }, { label: '门店提交', val: 81 }],
            [{ label: '已提交', val: 428 }, { label: '未提交', val: 100 }]
          ]
        },
        {
          title: '门店检查',
          rows: [
            [{ label: '本月工单', val: 486 }, { label: '待处理', val: 63 }],
            [{ label: '处理中', val: 102 }, { label: '超期', val: 29 }]
          ]
        },
        {
          title: '课程学习',
          rows: [
            [{ label: '在线课程', val: 142 }, { label: '店长完成', val: 79 }],
            [{ label: '导购完成', val: 68 }, { label: '人均时长', val: 4.6 }]
          ]
        },
        {
          title: '问卷调查',
          rows: [
            [{ label: '本月调研', val: 15 }, { label: '响应率', val: 64 }],
            [{ label: '已提交数', val: 3840 }, { label: '未提交数', val: 2160 }]
          ]
        }
      ],
      // 图表实例
      radarChart: null,
      barChart: null,
      lineChart: null,
      // 后端原始图表数据缓存
      chartModules: [],
      chartRateTrends: [],
      chartRegions: []
    }
  },
  mounted() {
    this.fetchData();
    // 延迟初始化图表，等待dom渲染完毕
    this.$nextTick(() => {
      this.initAllChart()
    })
    // 窗口自适应重绘
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    // 销毁echarts实例
    this.radarChart && this.radarChart.dispose()
    this.barChart && this.barChart.dispose()
    this.lineChart && this.lineChart.dispose()
  },
  computed: {
    // 根据切换标签自动绑定表格数据
    tableList() {
      if (this.activeTab === 'attention') {
        return this.attentions
      } else {
        return this.excellents
      }
    }
  },
  methods: {
    goToWorkbench() {
      window.location.replace("https://uat.lingshutong.cn/#/desktop")
    },
    switchTime(type) {
      this.activeTime = type
      // 在这里调用接口重新查询数据，把type传给后端
      this.fetchData(type)
    },
    // 初始化所有图表：实例不存在才初始化，不重复init
    initAllChart() {
      if (!this.radarChart) this.initRadar()
      if (!this.barChart) this.initBar()
      if (!this.lineChart) this.initLine()
    },
    // 雷达图：只初始化空壳，不填充动态数据
    initRadar() {
      const dom = this.$refs.radarRef
      console.log('radar dom', dom)
      if (!dom) return
      this.radarChart = echarts.init(dom)
      const option = {
        tooltip: {},
        legend: {
          right: 10,
          top: 10,
          orient: 'horizontal',
          data: []
        },
        radar: {
          indicator: [], // 由updateRadarOption动态赋值
          radius: '70%',
          splitArea: {
            areaStyle: {
              color: ['#f0f8e8', '#e4f2d6', '#d0e9b8']
            }
          }
        },
        series: []
      }
      this.radarChart.setOption(option)
    },
    // 更新雷达图：完全根据后端modules动态渲染
    updateRadarOption() {
      if (!this.radarChart) return
      const modules = this.chartModules || []
      if(!modules.length) return

      const txt = this.timeTextMap[this.activeTime]

      // 动态生成雷达指示器indicator
      const indicator = modules.map(m => ({
        name: m.name,
        max:100 // 加上max，指标轴最大100，防止刻度错乱
      }))

      // 本期数据 nowRates
      const currentData = modules.map(m => m.nowRates || 0)
      // 上期数据 preRates
      const prevData = modules.map(m => m.preRates || 0)

      this.radarChart.setOption({
        legend: {
          data: [txt.current + '完成', txt.prev + '完成']
        },
        radar: {
          indicator: indicator
        },
        series: [
          {
            name: txt.current + '完成',
            type: 'radar',
            data: [ currentData ], // 包一层数组！！
            areaStyle: { color: 'rgba(150, 210, 100, 0.4)' },
            lineStyle: { color: '#72b847' }
          },
          {
            name: txt.prev + '完成',
            type: 'radar',
            data: [ prevData ], // 包一层数组！！
            areaStyle: { color: 'rgba(180,180,180,0.2)' },
            lineStyle: { color: '#999' }
          }
        ]
      })
    },
    // 折线图
    updateLineOption() {
      if (!this.lineChart) return
      const trendList = this.chartRateTrends || []
      if (!trendList.length) return

      // x轴日期：取第一条的items拿dateName（所有模块日期一致）
      const xAxisData = trendList[0].items.map(item => item.dateName)

      // 动态生成series
      const series = trendList.map(mod => {
        return {
          name: mod.name,
          type: 'line',
          // 取出每一个时间点的rate
          data: mod.items.map(i => i.rate || 0)
        }
      })

      // legend取每个模块name
      const legendData = trendList.map(mod => mod.name)

      this.lineChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: {
          data: legendData
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: { min: 0, max: 100 },
        series: series
      })
    },
    updateBarOption() {
      if (!this.barChart) return
      const regions = this.chartRegions || []

      if (!regions.length) {
        // 返回空：图例清空，只显示暂无数据，不再遗留截图那一排色块
        this.barChart.setOption({
          legend: { data: [] },
          xAxis: { data: [] },
          series: [],
          graphic: [
            {
              type: 'text',
              left: 'center',
              top: 'center',
              style: {
                text: '暂无数据',
                fontSize: 14,
                fill: '#999'
              }
            }
          ]
        })
        return
      }

      // 原有真实数据逻辑不变
      const xAxisData = regions.map(r => r.name)
      const moduleNames = regions[0].modules.map(m => m.name)
      const series = moduleNames.map(name => {
        return {
          name,
          type: 'bar',
          data: regions.map(region => {
            const find = region.modules.find(m => m.name === name)
            return find ? (find.nowRates || 0) : 0
          })
        }
      })

      this.barChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: moduleNames },
        xAxis: { data: xAxisData },
        yAxis: { min: 0, max: 100 },
        series: series,
        graphic: []
      })
    },
    // 柱状图
    initBar() {
      const dom = this.$refs.barRef
      if (!dom || this.barChart) return
      this.barChart = echarts.init(dom)
      const option = {
        tooltip: {},
        legend: {
          data: []
        },
        dataZoom: [
          {
            type: 'slider',
            orient: 'horizontal',
            height: 18,
            start: 0,
            end: 85
          }
        ],
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: { type: 'value', max: 100 },
        series: []
      }
      this.barChart.setOption(option)
    },
    // 折线趋势图
    initLine() {
      const dom = this.$refs.lineRef
      if (!dom || this.lineChart) return
      this.lineChart = echarts.init(dom)
      const option = {
        tooltip: { trigger: 'axis' },
        legend: { data: [] },
        xAxis: { type: 'category', data: [] },
        yAxis: { min: 0, max: 100 },
        series: []
      }
      this.lineChart.setOption(option)
    },
    // 窗口缩放重绘图表
    resizeChart() {
      this.radarChart && this.radarChart.resize()
      this.barChart && this.barChart.resize()
      this.lineChart && this.lineChart.resize()
    },
    async fetchData(type) {
      if (this.loading) return
      this.loading = true
      try {
        const params = {
          "type": type //类型,1:昨天 2:本周 3:本月 4:本季度 5:本年
        }

        // let data = this.mockDashboardData()
        // this.formatData(data)
        const res = await axios.post(window.pubServer+'/external/boss', params)
        if (res.data.result && res.data.code === 200) {
          const data = res.data.data.data
          this.formatData(data)
        } else {
          this.$message.warning(res.data.message || '数据获取失败')
        }
      } catch (err) {
        console.error(err)
        this.$message.error('接口请求异常')
      } finally {
        this.loading = false
      }
    },

    // 模拟后端返回完整假数据，结构严格对齐接口返回
    mockDashboardData() {
      return {
        // 顶部汇总指标
        summarize: {
          doorTotal: 528,
          doorAdds: 12,
          doorActiveRates: 86.5,
          doorActiveRateChanges: 2.3,
          taskRates: 78.4,
          taskRateChanges: 1.6,
          doorFollows: 32,
          taskTimeouts: 147,
          taskTimeoutChanges: 18,
          courseRates: 72.3,
          courseRateChanges: 4.1
        },
        // 雷达图模块数据
        modules: [
          { name: '巡店任务', nowRates: 82, preRates: 76 },
          { name: '活动陈列', nowRates: 75, preRates: 70 },
          { name: '开放问卷', nowRates: 88, preRates: 81 },
          { name: '门店检查', nowRates: 70, preRates: 65 },
          { name: '课程学习', nowRates: 66, preRates: 62 },
          { name: '问卷调查', nowRates: 79, preRates: 73 },
          { name: '日常自查', nowRates: 79, preRates: 73 }
        ],
        // 门店排序数据：待关注门店 + 优秀门店TOP50
        doorSort: {
          attentions: [
            { doorName: '沈阳中街旗舰店', regionName: '华北区', hcName: '张某', taskRates: 59 },
            { doorName: '兰州西关百盛店', regionName: '华西区', hcName: '王某', taskRates: 55 },
            { doorName: '西安未央万象城店', regionName: '西北区', hcName: '李某', taskRates: 48 },
            { doorName: '成都春熙路店', regionName: '华西区', hcName: '赵某', taskRates: 52 }
          ],
          excellents: [
            { doorName: '上海陆家嘴中心店', regionName: '华东区', hcName: '钱某', taskRates: 96 },
            { doorName: '杭州湖滨银泰店', regionName: '华东区', hcName: '孙某', taskRates: 93 },
            { doorName: '广州天河城店', regionName: '华南区', hcName: '周某', taskRates: 91 }
          ]
        },
        // 区域柱状图数据源
        regions: [
          {
            name: '华东区',
            modules: [
              { name: '巡店任务', nowRates: 92 },
              { name: '活动陈列', nowRates: 88 },
              { name: '开放问卷', nowRates: 94 },
              { name: '门店检查', nowRates: 86 },
              { name: '课程学习', nowRates: 80 },
              { name: '问卷调查', nowRates: 85 }
            ]
          },
          {
            name: '华南区',
            modules: [
              { name: '巡店任务', nowRates: 88 },
              { name: '活动陈列', nowRates: 83 },
              { name: '开放问卷', nowRates: 90 },
              { name: '门店检查', nowRates: 81 },
              { name: '课程学习', nowRates: 76 },
              { name: '问卷调查', nowRates: 79 }
            ]
          },
          {
            name: '华北区',
            modules: [
              { name: '巡店任务', nowRates: 76 },
              { name: '活动陈列', nowRates: 72 },
              { name: '开放问卷', nowRates: 80 },
              { name: '门店检查', nowRates: 68 },
              { name: '课程学习', nowRates: 62 },
              { name: '问卷调查', nowRates: 70 }
            ]
          },
          {
            name: '华北区',
            modules: [
              { name: '巡店任务', nowRates: 76 },
              { name: '活动陈列', nowRates: 72 },
              { name: '开放问卷', nowRates: 80 },
              { name: '门店检查', nowRates: 68 },
              { name: '课程学习', nowRates: 62 },
              { name: '问卷调查', nowRates: 70 }
            ]
          },
          {
            name: '华北区',
            modules: [
              { name: '巡店任务', nowRates: 76 },
              { name: '活动陈列', nowRates: 72 },
              { name: '开放问卷', nowRates: 80 },
              { name: '门店检查', nowRates: 68 },
              { name: '课程学习', nowRates: 62 },
              { name: '问卷调查', nowRates: 70 }
            ]
          },
          {
            name: '华北区',
            modules: [
              { name: '巡店任务', nowRates: 76 },
              { name: '活动陈列', nowRates: 72 },
              { name: '开放问卷', nowRates: 80 },
              { name: '门店检查', nowRates: 68 },
              { name: '课程学习', nowRates: 62 },
              { name: '问卷调查', nowRates: 70 }
            ]
          },
          {
            name: '华北区',
            modules: [
              { name: '巡店任务', nowRates: 76 },
              { name: '活动陈列', nowRates: 72 },
              { name: '开放问卷', nowRates: 80 },
              { name: '门店检查', nowRates: 68 },
              { name: '课程学习', nowRates: 62 },
              { name: '问卷调查', nowRates: 70 }
            ]
          },
          {
            name: '华北区',
            modules: [
              { name: '巡店任务', nowRates: 76 },
              { name: '活动陈列', nowRates: 72 },
              { name: '开放问卷', nowRates: 80 },
              { name: '门店检查', nowRates: 68 },
              { name: '课程学习', nowRates: 62 },
              { name: '问卷调查', nowRates: 70 }
            ]
          },
          {
            name: '西北区',
            modules: [
              { name: '巡店任务', nowRates: 71 },
              { name: '活动陈列', nowRates: 68 },
              { name: '开放问卷', nowRates: 74 },
              { name: '门店检查', nowRates: 63 },
              { name: '课程学习', nowRates: 58 },
              { name: '问卷调查', nowRates: 65 }
            ]
          }
        ],
        // 区域排行表格
        regionSort: [
          { name: '华东区', nowRates: 92.31 },
          { name: '华南区', nowRates: 86.72 },
          { name: '华北区', nowRates: 74.55 },
          { name: '西北区', nowRates: 68.28 }
        ],
        // 业务详情模块
        moduleDetails: [
          {
            name: '巡店任务',
            indicators: [
              { name: '本月巡店', value: 312 },
              { name: '平均得分', value: 82.6 },
              { name: '不合格项', value: 186 },
              { name: '整改完成', value: 73 }
            ]
          },
          {
            name: '活动陈列',
            indicators: [
              { name: '本月活动', value: 24 },
              { name: '提交单', value: 88 },
              { name: '审核通过', value: 76 },
              { name: '待审核', value: 42 }
            ]
          },
          {
            name: '开放问卷',
            indicators: [
              { name: '本月问卷', value: 8 },
              { name: '门店提交', value: 81 },
              { name: '已提交', value: 428 },
              { name: '未提交', value: 100 }
            ]
          },
          {
            name: '门店检查',
            indicators: [
              { name: '本月工单', value: 486 },
              { name: '待处理', value: 63 },
              { name: '处理中', value: 102 },
              { name: '超期', value: 29 }
            ]
          },
          {
            name: '课程学习',
            indicators: [
              { name: '在线课程', value: 142 },
              { name: '店长完成', value: 79 },
              { name: '导购完成', value: 68 },
              { name: '人均时长', value: 4.6 }
            ]
          },
          {
            name: '问卷调查',
            indicators: [
              { name: '本月调研', value: 15 },
              { name: '响应率', value: 64 },
              { name: '已提交数', value: 3840 },
              { name: '未提交数', value: 2160 }
            ]
          }
        ],
        // 完成率趋势（折线图，你当前代码还没使用rateTrends，后面可以对接折线）
        rateTrends: [
          { date: '第一t', values: [82,78,74,70,66,62,11] },
          { date: '第二周', values: [88,84,80,76,72,68,12] },
          { date: '第三周', values: [80,76,70,66,58,54,22] },
          { date: '第四周', values: [84,80,76,72,64,60,8] }
        ]
      }
    },

    // 格式化后端返回数据，赋值给页面变量
    formatData(data) {
      const { summarize, modules, doorSort, regions, regionSort, moduleDetails, rateTrends } = data

      const txt = this.timeTextMap[this.activeTime]

      // 缓存图表原始接口数据
      this.chartModules = modules
      this.chartRateTrends = data.rateTrends || []
      this.chartRegions = regions

      // 1、顶部指标卡片 summarize 映射
      this.indicatorData = [
        { label: '门店数', value: summarize.doorTotal, compareText: `${txt.current}新增${summarize.doorAdds}家`, up: true },
        { label: '活跃门店率', value: summarize.doorActiveRates, compareText: `较${txt.prev} ↑ ${summarize.doorActiveRateChanges}%`, up: true },
        { label: '任务总完成率', value: summarize.taskRates, compareText: `较${txt.prev} ↓ ${summarize.taskRateChanges}%`, up: false },
        { label: '待关注门店', value: summarize.doorFollows, compareText: '完成率 < 60%', up: false },
        { label: '超期任务', value: summarize.taskTimeouts, compareText: `较${txt.prev} ↑ ${summarize.taskTimeoutChanges} 项`, up: false },
        { label: '课程平均完成率', value: summarize.courseRates, compareText: `较${txt.prev} ↑ ${summarize.courseRateChanges}%`, up: true }
      ]

      // 2、待关注门店列表
      this.attentions = doorSort.attentions.map(item => ({
        shopName: item.doorName,
        region: item.regionName,
        manager: item.hcName || '-',
        rate: item.taskRates
      }))

      this.excellents = doorSort.excellents.map(item => ({
        shopName: item.doorName,
        region: item.regionName,
        manager: item.hcName || '-',
        rate: item.taskRates
      }))

      // 3、区域综合排行
      this.regionRankList = regionSort.map(item => ({
        area: item.name,
        rate: Number(item.nowRates.toFixed(2))
      }))

      // 4、业务详情 moduleDetails
      this.businessList = moduleDetails.map(mod => {
        const rows = []
        const arr = mod.indicators
        // 每两个指标一行
        for (let i = 0; i < arr.length; i += 2) {
          const chunk = []
          if (arr[i]) chunk.push({ label: arr[i].name, val: arr[i].value })
          if (arr[i + 1]) chunk.push({ label: arr[i + 1].name, val: arr[i + 1].value })
          rows.push(chunk)
        }
        return {
          title: mod.name,
          rows
        }
      })

      // 数据赋值完成后初始化渲染图表
      this.initAllChart()
      this.$nextTick(() => {
        // 更新雷达图，切换时间只执行setOption
        this.updateRadarOption()
        // 更新区域执行力对比柱状图
        this.updateBarOption()
        // 更新折线图
        this.updateLineOption()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.time-tab-wrap {
  display: flex;
  gap: 10px;
  margin: 16px 0;
}
.time-tab {
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  border-radius: 1px;
}
.time-tab.active {
  background-color: #50b83c;
  color: #fff;
}
.tab-wrap {
  margin-bottom: 8px;
}
.tab-item {
  font-size: 12px;
  margin-right: 24px;
  cursor: pointer;
  color: #666;
}
.tab-item.active {
  color: green;
  font-weight: bold;
}
.dashboard-container {
  padding: 12px;
  font-size: 13px;
  color: #333;
  background: #fff;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
  .header-right {
    display: flex;
    align-items: center;
    gap: 20px;
  }
}
.filter-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  .time-tabs {
    .tab-item {
      padding: 4px 12px;
      cursor: pointer;
      border-radius: 4px;
      &.active {
        background: #72b847;
        color: #fff;
      }
    }
  }
  .select-group {
    display: flex;
    gap: 10px;
  }
}
// 顶部指标卡片
.indicator-row {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  margin-bottom: 16px;
  .indicator-card {
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 12px;
    .num {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .label {
      color: #666;
      margin-bottom: 4px;
    }
    .compare-text {
      font-size: 12px;
      &.text-green {
        color: #00a854;
      }
      &.text-red {
        color: #f5222d;
      }
    }
  }
}
// 双列图表行
// 双列图表行
.chart-row {
  margin-bottom: 16px;
  &.two-col {
    // 左侧65%，右侧35%
    display: grid;
    grid-template-columns: 65% 35%;
    gap: 16px;
  }
  .chart-card {
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 12px;
    .card-title {
      font-weight: bold;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .legend-desc {
        font-weight: normal;
        font-size: 12px;
        .green-block {
          display: inline-block;
          width: 10px;
          height: 10px;
          background: #72b847;
          margin-right: 4px;
        }
        .gray-block {
          display: inline-block;
          width: 10px;
          height: 10px;
          background: #999;
          margin-right: 4px;
        }
      }
      .sub-tip {
        font-weight: normal;
        font-size: 12px;
        color: #999;
      }
    }
    .table-tag {
      margin-bottom: 8px;
      .tag-red {
        color: #f5222d;
        margin-right: 12px;
      }
      .tag-gray {
        color: #666;
      }
    }
    .chart-dom {
      width: 100%;
      height: 320px;
    }
    .small-desc {
      font-size: 11px;
      color: #888;
    }
    .progress-box {
      display: flex;
      align-items: center;
      gap: 6px;
      .progress-bar {
        height: 8px;
        background: #72b847;
        border-radius: 4px;
        max-width: 120px;
      }
    }
  }
}
// 通栏卡片
.full-card {
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
  .card-title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .chart-dom {
    width: 100%;
    height: 320px;
  }
}
// 业务详情网格
.business-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  .business-item {
    border: 1px solid #eee;
    padding: 10px;
    border-radius: 4px;
    .biz-title {
      font-weight: bold;
      margin-bottom: 8px;
      padding-bottom: 6px;
      border-bottom: 1px solid #eee;
    }
    .biz-row {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      margin: 6px 0;
      font-size: 12px;
    }
  }
}
.back-workbench {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 30px;
  //color: #fff;
  cursor: pointer;
}
.back-workbench .arrow {
  font-size: 30px;
}
.back-workbench:hover {
  opacity: 0.8;
}
.bar-scroll-wrap {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  .chart-dom {
    min-width: 700px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard.vue